import React from "react";
import { theme } from "../theme.js";

export default function StickyColumn({ children, title, topOffset = "100px" }) {
  return (
    <div style={{...styles.container, top: topOffset}}>
      {title && <h2 style={styles.title}>{title}</h2>}
      <div style={styles.content}>
        {children}
      </div>
    </div>
  );
}

const styles = {
  container: {
    position: "sticky",
    width: "100%",
    maxWidth: "500px",
    backgroundColor: theme.colors.white,
    border: `1px solid ${theme.colors.border}`,
    borderRadius: theme.radius.lg,
    padding: theme.spacing.lg,
    height: "fit-content",
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.md,
    boxShadow: theme.shadows?.light || "0 1px 3px rgba(0,0,0,0.1)",
  },
  title: {
    fontSize: theme.fonts.size.lg,
    fontWeight: theme.fonts.weight.bold,
    color: theme.colors.textInverted,
    margin: "0 0 " + theme.spacing.md + " 0",
    paddingBottom: theme.spacing.md,
    borderBottom: `1px solid ${theme.colors.border}`,
  },
  content: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.md,
  },
};
